import { CustomDay, DateUtils } from '@eo-storefronts/eo-core'
import { Box, TextField, Typography } from '@mui/material'
import { ChangeEvent, useEffect, useState } from 'react'
import { useEoState, useEoValue } from '~/src/hooks/useEoState'
import { useTranslations } from '~/src/hooks/useTranslations'
import { getCustomDays } from '~/src/services/DeliveryTimeService'
import { CHECKOUT_FORM_STATE, CheckoutFormState } from '~/src/stores/checkout'
import { FIRM_SELECTOR } from '~/src/stores/firm'
import { LANGUAGE_STATE } from '~/src/stores/lang'

const DeliveryMethodsCustomDays = () => {
  const { t } = useTranslations()
  const firm = useEoValue(FIRM_SELECTOR)
  const [ checkoutForm, setCheckoutForm ] = useEoState(CHECKOUT_FORM_STATE)
  const lang = useEoValue(LANGUAGE_STATE)
  const [ customDays, setCustomDays ] = useState<string[]>([])

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    setCheckoutForm((state: CheckoutFormState) => ({
      ...state,
      delivery_method: {
        ...state.delivery_method,
        time: event.target.value !== '' ? event.target.value : null
      }
    }))
  }

  useEffect(() => {
    if (!firm || !checkoutForm.delivery_method.method) {
      return
    }

    const apiCustomDays = getCustomDays(firm, checkoutForm.delivery_method.method)
      .map((customDay: CustomDay) => customDay.date)

    setCustomDays(apiCustomDays)
  }, [ firm, checkoutForm.delivery_method.method ])

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <Typography>{t('delivery_methods.custom_day_selector')}</Typography>
      {customDays.length === 0 && <Typography color='error'>{t('delivery_methods.no_more_custom_days_available')}</Typography>}
      {customDays.length !== 0 && (
        <TextField
          select
          size='small'
          SelectProps={{
            native: true
          }}
          variant='outlined'
          onChange={handleOnChange}
          value={checkoutForm.delivery_method.time || ''}
        >
          <option value=''>{t('delivery_methods.choose_time')}</option>
          {
            customDays.map((customDay: string, index: number) => (
              <option
                key={index}
                value={customDay}
              >
                {DateUtils.format(new Date(customDay), lang)}
              </option>
            ))
          }
        </TextField>
      )}
    </Box>
  )
}

export default DeliveryMethodsCustomDays
